import { motion, MotionValue, useTransform, type MotionStyle } from "motion/react";
import cx from "classnames";
import { useContext } from "react";
import { ScrollAnimContext } from "@/contexts/ScrollAnimContext";

export default function Highlight({
  children,
  className,
  scrollProgress,
  highlightStyles,
}: {
  children: React.ReactNode;
  className?: string;
  scrollProgress?: MotionValue<number>;
  highlightStyles?: MotionStyle;
}) {
  // Obtain current scroll position
  const scrollYProgress = useContext(ScrollAnimContext);

  // Animate the highlight coming in from left to right
  const width = useTransform(scrollProgress ?? scrollYProgress, [0, 0.05], ["0%", "100%"]);

  return (
    <div className={cx("relative", className)}>
      <p>{children}</p>
      <motion.div className='bg-blue-200 h-full -z-10 absolute top-0 left-0' style={{ width, ...highlightStyles }} />
    </div>
  );
}
